import React from 'react';

import { Title } from '@components/Title';
import { TextBlock } from '@components/TextBlock';

import { useThemeGetter } from '@hooks';

import {
  ProfileBoxContainer,
  ProfileInfoBoxContainer,
  ProfileInfoBoxTextContainer,
} from './ProfileInfoBox.styled';

import { ProfileInfoBoxProps } from './ProfileInfoBox.types';

export const ProfileInfoBox = ({
  title = 'About me',
  infoList = [],
}: ProfileInfoBoxProps) => {
  const {
    theme: { Title: TitleColor, Background, BlockShadow, Text: TextColor },
  } = useThemeGetter();

  return (
    <ProfileBoxContainer>
      <ProfileInfoBoxContainer shadow={BlockShadow} bgColor={Background}>
        <Title size={4} text={title} color={TitleColor} align="left" />
        <ProfileInfoBoxTextContainer>
          {infoList.map((one) => (
            <TextBlock
              key={one}
              text={one}
              align="left"
              indent={20}
              color={TextColor}
            />
          ))}
        </ProfileInfoBoxTextContainer>
      </ProfileInfoBoxContainer>
    </ProfileBoxContainer>
  );
};
